import { initWebWorker } from './components/workerHandler'
import initSlider from './components/slider'
import initNewsletterPopup from './components/newsletterPopup'
import { inithandleExchangeButton } from 'components/continue-button'

initWebWorker()
initSlider()
initNewsletterPopup()
inithandleExchangeButton()
